import React from "react";
import { useTranslation } from "react-i18next";
import { DetailsWrapper } from "../../../components/details-wrapper/details-wrapper";
import { AddBookForm } from "../../../components/publisher/my-books/add-book/add-book-form";

const PublisherMyBookCreatePage = () => {
    const { t } = useTranslation('publisher');

    return (
        <DetailsWrapper description={t('addBook.pageDesc')}>
            <AddBookForm/>
        </DetailsWrapper>
    )
}

export default PublisherMyBookCreatePage;
